module.exports = __webpack_public_path__ + "files/400ce6dc2c3135e89e919e012590718a.svg";